/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A dictionary of contact information
 * @export
 * @interface ContactInfo
 */
export interface ContactInfo {
    /**
     * The phone number.
     * @type {string}
     * @memberof ContactInfo
     */
    phone?: string;
    /**
     * The first line of the street address.
     * @type {string}
     * @memberof ContactInfo
     */
    streetAddressLine1?: string;
    /**
     * The second line of the street address.
     * @type {string}
     * @memberof ContactInfo
     */
    streetAddressLine2?: string;
    /**
     * The city.
     * @type {string}
     * @memberof ContactInfo
     */
    city?: string;
    /**
     * The state.
     * @type {string}
     * @memberof ContactInfo
     */
    state?: string;
    /**
     * The zip code.
     * @type {string}
     * @memberof ContactInfo
     */
    zip?: string;
    /**
     * The country.
     * @type {string}
     * @memberof ContactInfo
     */
    country?: string;
}

/**
 * Check if a given object implements the ContactInfo interface.
 */
export function instanceOfContactInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactInfoFromJSON(json: any): ContactInfo {
    return ContactInfoFromJSONTyped(json, false);
}

export function ContactInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'streetAddressLine1': !exists(json, 'streetAddressLine1') ? undefined : json['streetAddressLine1'],
        'streetAddressLine2': !exists(json, 'streetAddressLine2') ? undefined : json['streetAddressLine2'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
        'country': !exists(json, 'country') ? undefined : json['country'],
    };
}

export function ContactInfoToJSON(value?: ContactInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phone': value.phone,
        'streetAddressLine1': value.streetAddressLine1,
        'streetAddressLine2': value.streetAddressLine2,
        'city': value.city,
        'state': value.state,
        'zip': value.zip,
        'country': value.country,
    };
}

